import { Flex, Text } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { ReactNode } from 'react';

export const StackedText = (props: { line1: ReactNode; line2: ReactNode }) => (
  <Flex direction="column" gap="2" pt="2" pb="2">
    <Text>{props.line1}</Text>
    <Text color={RADIX.COLOR.SECONDARY}>{props.line2}</Text>
  </Flex>
);
